import { customAlphabet } from 'nanoid';
// Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
// This is assuming 100.000 ids per hour.
// src: https://zelark.github.io/nano-id-cc/
export const easyToSpeakId = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);
//# sourceMappingURL=generateId.js.map